import {
    infectionPreventionLabel,
    localizeInfectionPreventionTerminology,
    sectorCareRecipientPossessive,
    sectorCareRecipientTerm,
} from '@/utils/sector';

export default {
    computed: {
        careRecipientTerm() {
            return sectorCareRecipientTerm(
                this.$userStore.getCompanySectorName
            );
        },
        careRecipientTermTitle() {
            return sectorCareRecipientTerm(
                this.$userStore.getCompanySectorName,
                {
                    capitalize: true,
                }
            );
        },
        careRecipientsTerm() {
            return sectorCareRecipientTerm(
                this.$userStore.getCompanySectorName,
                {
                    plural: true,
                }
            );
        },
        careRecipientsTermTitle() {
            return sectorCareRecipientTerm(
                this.$userStore.getCompanySectorName,
                {
                    plural: true,
                    capitalize: true,
                }
            );
        },
        careRecipientsPossessive() {
            return sectorCareRecipientPossessive(
                this.$userStore.getCompanySectorName
            );
        },
        underSurveillanceSectionLabel() {
            return `${this.careRecipientsTermTitle} Under Surveillance`;
        },
        infectionPreventionLabel() {
            return infectionPreventionLabel(
                this.$userStore?.company?.country,
                this.$userStore?.effectiveLocale
            );
        },
    },
    methods: {
        localizeInfectionPreventionTerminology(value) {
            return localizeInfectionPreventionTerminology(
                value,
                this.$userStore?.company?.country,
                this.$userStore?.effectiveLocale
            );
        },
    },
};
